export const partnerLinks = {
  mspark: 'https://mspark.ac/',
}
